export enum PAGE_TYPE {
  SEARCH_DESTINATIONS = 'searchDestinations',
  SEARCH = 'search',
  HOTEL_DETAIL = 'hotelDetail',
  TRANSPORT_DETAIL = 'transportDetail',
  REVIEW = 'review',
}

// The results steps of the funnel; every other page type is a detail step (hotel, flights, review).
export const RESULTS_STEP_PAGE_TYPES: PAGE_TYPE[] = [PAGE_TYPE.SEARCH, PAGE_TYPE.SEARCH_DESTINATIONS];
